/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSubTask.vue?vue&type=template&id=0bfb7132&scoped=true"
import script from "./popSubTask.vue?vue&type=script&lang=js"
export * from "./popSubTask.vue?vue&type=script&lang=js"
import style0 from "./popSubTask.vue?vue&type=style&index=0&id=0bfb7132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb7132",
  null
  
)

export default component.exports